import validate from "/var/www/node_modules/.pnpm/nuxt@4.4.8_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@babel+plugin-syntax-typ_f88ca4ddfd0bfdff048c5d28a6e81f57/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/www/node_modules/@backmarket/nuxt-layer-oauth/app/middleware/auth.global.ts";
import guest_45global from "/var/www/node_modules/@backmarket/nuxt-layer-oauth/app/middleware/guest.global.ts";
import log_45ds_45version_45global from "/var/www/node_modules/@backmarket/nuxt-layer-design-system/app/middleware/logDsVersion.global.ts";
import _01_45client_45side_45navigation_45global from "/var/www/node_modules/@backmarket/nuxt-layer-base/app/middleware/01.clientSideNavigation.global.ts";
import intercom_45global from "/var/www/apps/front-office/app/middleware/intercom.global.ts";
import payment_45content_45security_45policies_45headers from "/var/www/packages/nuxt-layer-payment/app/scopes/content-security-policies/middleware/paymentContentSecurityPoliciesHeaders.global.ts";
import logger from "/var/www/packages/nuxt-module-logger/src/runtime/middleware.ts";
import httpCache_46addCacheControlHeader from "/var/www/packages/nuxt-module-http-cache/src/runtime/middleware/addCacheControlHeader.ts";
import instrumentation_46setResourceName from "/var/www/packages/nuxt-module-instrumentation/src/runtime/middleware/setResourceName.ts";
import loadRouteTranslations_46global from "/var/www/packages/nuxt-module-i18n/src/runtime/middleware/loadRouteTranslations.global.ts";
import manifest_45route_45rule from "/var/www/node_modules/.pnpm/nuxt@4.4.8_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@babel+plugin-syntax-typ_f88ca4ddfd0bfdff048c5d28a6e81f57/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  guest_45global,
  log_45ds_45version_45global,
  _01_45client_45side_45navigation_45global,
  intercom_45global,
  payment_45content_45security_45policies_45headers,
  logger,
  httpCache_46addCacheControlHeader,
  instrumentation_46setResourceName,
  loadRouteTranslations_46global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "buyback-button-enabled": () => import("/var/www/node_modules/@backmarket/nuxt-layer-buyback/app/middleware/buybackButtonEnabled.ts"),
  "buyback-enabled": () => import("/var/www/node_modules/@backmarket/nuxt-layer-buyback/app/middleware/buybackEnabled.ts"),
  "hide-consent-notice": () => import("/var/www/apps/front-office/app/middleware/hideConsentNotice.ts")
}